// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"3df3cb77","433":"3912f4f9","637":"8effeeaa","763":"178e9598","768":"c0b0a7de"}[chunkId] + ".chunk.js";
};